import { AccountantConnection, UserWorkspaceSetting } from '../types'
import Api from './Api'

export default class TeamController extends Api {
	static getTeam(): Promise<{ team: UserWorkspaceSetting[], accountants: AccountantConnection[] }> {
		return fetch('/api/team', {
			method: 'GET',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': this.token
			},
			credentials: 'same-origin',
		})
			.then(res => res.json())
	}

}
